// store.js
import { defineStore } from 'pinia';

export const useStore = defineStore({
  id: 'store_data',
  state: () => ({
    user_id: '',
    user_data: '',
  }),
  actions: {
    // Define actions if needed
  },
  getters: {
    // Define getters if needed
  },
  mutations: {
    setUserData(state, userData) {
      state.user_data = userData;
    }
  },
  persist: {
    enabled: true
  }
  // You can also define mutations, but Pinia automatically generates them
});